<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 <meta charset="utf-8"/> <link href="styles/default.css" rel="stylesheet" type="text/css"/> <title>Volume One</title>
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Volume One">
<p class="tx52" id="p0015-01-0">
<b>44 </b>
<a id="page15">
<span class="st1"> Write “thank you” notes promptly.</span>
</a></p><a id="page15">
<p class="tx52" id="p0015-01-1">
<b>45 </b>
<span class="st1"> Show respect for teachers.</span>
</p>
<p class="tx52" id="p0015-01-2">
<b>46 </b>
<span class="st1">Show respect for police officers and firefighters.</span>
</p>
<p class="tx52" id="p0015-01-3">
<b>47 </b>
<span class="st1">Show respect for military personnel.</span>
</p>
<p class="tx52" id="p0015-P-1">
<b>48 </b>
<span class="st1">Don’t waste time learning the “tricks of the trade.” Instead, learn the trade.</span>
</p>
<p class="tx52" id="p0015-P-2">
<b>49 </b>
<span class="st1">Keep a tight rein on your temper.</span>
</p>
<p class="tx52" id="p0015-01-4">
<b>50 </b>
<span class="st1">Buy vegetables from truck farmers who advertise with hand-lettered signs.</span>
</p>
<p class="tx52" id="p0015-01-5">
<b>51 </b>
<span class="st1">Put the cap back on the toothpaste.</span>
</p>
</a><p class="tx52" id="p0016-P-1"><a id="page15">
</a><a id="page16">
<b>52 </b>
<span class="st1">Take out the garbage without being told.</span>
</a></p><a id="page16">
<p class="tx52" id="p0016-01-1">
<b>53 </b>
<span class="st1">Avoid overexposure to the sun.</span>
</p>
<p class="tx52" id="p0016-01-2">
<b>54 </b>
<span class="st1">Vote.</span>
</p>
<p class="tx52" id="p0016-01-3">
<b>55 </b>
<span class="st1">Surprise loved ones with little unexpected gifts.</span>
</p>
<p class="tx52" id="p0016-01-4">
<b>56 </b>
<span class="st1">Stop blaming others. Take responsibility for every area of your life.</span>
</p>
<p class="tx52" id="p0016-01-5">
<b>57 </b>
<span class="st1">Never mention being on a diet.</span>
</p>
<p class="tx52" id="p0016-01-6">
<b>58 </b>
<span class="st1">Make the best of bad situations.</span>
</p>
<p class="tx52" id="p0016-01-7">
<b>59 </b>
<span class="st1">Learn to make something beautiful with your hands.</span>
</p>
</a><p class="tx52" id="p0017-P-1"><a id="page16">
</a><a id="page17">
<b>60 </b>
<span class="st1">Live so that when your children think of fairness, caring, and integrity, they think of you.</span>
</a></p><a id="page17">
<p class="tx52" id="p0017-01-1">
<b>61 </b>
<span class="st1">Support a high school band.</span>
</p>
<p class="tx52" id="p0017-01-2">
<b>62 </b>
<span class="st1">Admit your mistakes.</span>
</p>
<p class="tx52" id="p0017-01-3">
<b>63 </b>
<span class="st1">Use your wit to amuse, not abuse.</span>
</p>
<p class="tx52" id="p0017-01-4">
<b>64 </b>
<span class="st1">Remember that all news is biased.</span>
</p>
<p class="tx52" id="p0017-01-5">
<b>65 </b>
<span class="st1">Take a photography course.</span>
</p>
<p class="tx52" id="p0017-01-6">
<b>66 </b>
<span class="st1">Let people pull in front of you when you’re stopped in traffic.</span>
</p>
<p class="tx52" id="p0017-01-7">
<b>67 </b>
<span class="st1">Always accept an outstretched hand.</span>
</p>
</a></section><a id="page17">
</a></div>
<a id="page17">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?3365668d